(function () {
  const hideShippingText = window.__productHasCustomShipping === true || window.__productHasNoShipping === true;

  // ── 1. Ascunde "Transport GRATUIT" dacă e custom profile SAU no shipping ──
  if (hideShippingText) {
    function hideShipping() {
      for (const el of document.querySelectorAll('*')) {
        if (
          el.children.length === 0 &&
          el.textContent.trim() === 'Transport GRATUIT pentru comenzi de peste 300 RON'
        ) {
          const target = el.parentElement;
          if (target) target.style.display = 'none';
          break;
        }
      }
    }

    hideShipping();
    const obs1 = new MutationObserver(hideShipping);
    obs1.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs1.disconnect(), 5000);
  }

  // ── 2. Afișează mesaj "no shipping" doar dacă e profilul fără livrare ──
  if (window.__productHasNoShipping === true) {
    function showNoShippingMessage() {
      if (document.getElementById('no-shipping-message')) return;

      const buyButton =
        document.querySelector('.shopify-payment-button__button--unbranded') ||
        document.querySelector('.button-add-to-cart') ||
        document.querySelector('button[type="submit"].add');

      if (!buyButton) return;

      const banner = document.createElement('div');
      banner.id = 'no-shipping-message';
      banner.innerHTML = `
        <div style="
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-top: 12px;
          padding: 12px 16px;
          background-color: #fff8f0;
          border: 1px solid #f0a500;
          border-radius: 6px;
          font-size: 14px;
          color: #7a4f00;
          font-family: inherit;
        ">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="#f0a500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            style="flex-shrink: 0; margin-top: 2px;">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <div style="display: flex; flex-direction: column; width: 100%;">
            <span style="padding-bottom: 8px; border-bottom: 1px solid #f0d090;">Acest produs nu este disponibil pentru livrare la domiciliu la nivel național.</span>
            <span style="padding-top: 8px;">Poate fi ridicat personal din magazinele Dacus din Reșița sau Caransebeș ori livrat în aria de acoperire a acestora.</span>
          </div>
        </div>
      `;

      buyButton.insertAdjacentElement('afterend', banner);
    }

    showNoShippingMessage();
    const obs2 = new MutationObserver(showNoShippingMessage);
    obs2.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs2.disconnect(), 5000);
  }
})();
